var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        id: "upgrade-needed",
        "show-footer": false,
        "show-title": false,
      },
      on: { cancel: _vm.cancel },
    },
    [
      _c("div", { staticClass: "upgrade-needed-content" }, [
        _c(
          "div",
          { staticClass: "upgrade-needed-content-title" },
          [
            _c("UpgradeIconSvg"),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.$t("message.upgradePackageTitle")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "upgrade-needed-content-description" },
          [
            _vm.descriptions[_vm.upgradeDetail.name]
              ? [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.descriptions[_vm.upgradeDetail.name]) +
                      "\n            "
                  ),
                ]
              : [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.moreFeaturesDesc")) +
                      "\n            "
                  ),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "upgrade-needed-content-content" },
          [_c("UpgradeSVG")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "upgrade-needed-content-footer" },
          [
            _c(
              "SupsisButton",
              { attrs: { primary: "" }, on: { click: _vm.upgrade } },
              [_vm._v(_vm._s(_vm.$t("message.upgradePackage")))]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }